import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { faSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Box,
    DialogContent,
    DialogProps,
    DialogTitle,
    IconButtonProps,
    Dialog as MuiDialog,
    IconButton as MuiIconButton,
    styled,
    Typography,
    useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import { MapContext } from "src/contexts/map";
import ElementDetails from "src/dialogs/ElementDetails";
import { Type_Element } from "src/types/element";
import { getIconFromPicto } from "src/utils/category";

const IconButton = styled(MuiIconButton)<IconButtonProps>(({ theme }) => ({
    color: theme.palette.primary.main,
    fontSize: "0.875rem",
    borderRadius: theme.spacing(1),
}));

const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
    marginRight: theme.spacing(0.5),
    fontSize: "1rem",
}));

const Dialog = styled(MuiDialog)<DialogProps>(({ theme }) => ({
    "& .MuiDialog-paper": {
        [theme.breakpoints.down("md")]: {
            position: "absolute",
            bottom: 0,
            margin: 0,
            width: "100%",
        },
    },
}));

type Type_Props_Mobile_Hover_Card = {
    setOverlayContent: () => void;
};

const MobileHoverCard = ({
    setOverlayContent,
}: Type_Props_Mobile_Hover_Card) => {
    const { t } = useTranslation();
    const { newElement: element, categories } = useContext(MapContext);
    const [showDetails, setShowDetails] = useState(false);
    const theme = useTheme();

    const handleCloseDetails = () => setShowDetails(false);

    const elementCategory = (elem: Type_Element) =>
        categories.find((category) => category.id === elem.category_id);

    if (!element) return null;

    return (
        <Dialog hideBackdrop open fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="right">
                    <FontAwesomeIcon
                        fontSize="0.8rem"
                        color={theme.palette.secondary.main}
                        icon={faTimes}
                        onClick={() => setOverlayContent()}
                    />
                </Box>

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Box component="span" display="flex" alignItems="center">
                        <Icon
                            icon={
                                elementCategory(element)?.picto
                                    ? getIconFromPicto(
                                          elementCategory(element)?.picto ?? "",
                                      )
                                    : faSquare
                            }
                            style={{ marginRight: 8 }}
                        />
                        <Typography>
                            <strong>{element.title}</strong>
                        </Typography>
                    </Box>

                    <IconButton onClick={() => setShowDetails(true)}>
                        <Icon icon={faEye} />
                        {t("see_more")}
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography fontSize="small" color="text.secondary">
                    <Box component="span" mr={1}>
                        {t("period")} :
                    </Box>
                    <strong>
                        <Box
                            component="span"
                            mr={1}
                            color={theme.palette.common.black}
                        >
                            {dayjs(element.start_date).format("L LT")}
                        </Box>
                    </strong>
                    <Box component="span" mr={1}>
                        {t("until")}
                    </Box>
                    <strong>
                        <Box
                            component="span"
                            mr={1}
                            color={theme.palette.common.black}
                        >
                            {dayjs(element.end_date).format("L LT")}
                        </Box>
                    </strong>
                </Typography>
            </DialogContent>
            {showDetails && <ElementDetails close={handleCloseDetails} />}
        </Dialog>
    );
};

export default MobileHoverCard;
